export default {
  searchSchool: ''
}



// WEBPACK FOOTER //
// ./src/components/schools/store/state.js